import { ReactNode } from 'react';

import { ConditionalWrapper } from '@cast/design-system';
import { useTrial } from '@cast/shared-trial-ui';

import { TrialOverlay } from 'components/trial/TrialOverlay';
import { useIsOrganizationReadOnly } from 'hooks/useIsOrganizationReadOnly';

export const ChartSectionTrialOverlay = ({
  children,
}: {
  children: ReactNode;
}) => {
  const accountReadOnly = useIsOrganizationReadOnly();

  const { isEligible } = useTrial();

  const displayBlurOverlay = isEligible && accountReadOnly;

  return (
    <ConditionalWrapper
      condition={displayBlurOverlay}
      wrapper={(child) => (
        <TrialOverlay
          heading="View Vertical rightsizing details over time"
          description="Learn more about the optimized cluster configuration and view the suggested list of nodes in our trial version."
          position={{ top: 4 }}
        >
          {child}
        </TrialOverlay>
      )}
    >
      {children}
    </ConditionalWrapper>
  );
};
